export const TYPE_PENDING = 'pending';
export const TYPE_ACCEPTED = 'accepted';
export const TYPE_FINISHED = 'finished';
export const TYPE_REJECTED = 'rejected';

export const TYPES = [
  TYPE_PENDING,
  TYPE_ACCEPTED,
  TYPE_FINISHED,
  TYPE_REJECTED
];
